module.exports = __webpack_public_path__ + "img/3.d5f3958d.png";